var map = {
	"./attack.gif": 91572,
	"./ded.gif": 73891,
	"./dmg.gif": 43716,
	"./idle.gif": 6698,
	"./low.gif": 79138,
	"./ougi.gif": 41772,
	"./ready.gif": 27821,
	"./results.jpg": 44526,
	"./win.gif": 52134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98675;